import * as DateF from 'date-fns'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Tooltip } from '@blade/ui-kit'
import { PairMigrationStatus } from '@root/entities/pair/model'
import { DATE_FORMAT } from '@root/shared'
import { MigrationIcon } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type PairMigratedIconProps = {
  size: number
  migration: PairMigrationStatus.PairMigrationStatus
} & ClassNameProps

export const PairMigratedIcon: React.FC<PairMigratedIconProps> = ({
  size,
  className,
  migration,
}) => {
  const { t } = useTranslation()

  if (!PairMigrationStatus.isMigrated(migration)) {
    return undefined
  }

  const tooltipContent =
    migration instanceof PairMigrationStatus.MigratedFrom ||
    migration instanceof PairMigrationStatus.MigratedTo
      ? t('pair.token-migrated-tooltip', {
          timestamp: DateF.format(
            migration.migration.migrationTimestamp,
            DATE_FORMAT.dd_MM_yy__HH_mm,
          ),
        })
      : undefined

  return (
    <Tooltip content={tooltipContent}>
      <Root style={{ width: size, height: size }} className={className}>
        <MigrationIcon width={size * 0.8} />
      </Root>
    </Tooltip>
  )
}

const Root = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;

  border: 1px solid var(--background-5);
  background: var(--background-1);
  color: var(--amber-9);

  left: -2px;
  bottom: -2px;
`
